import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse } from 'types';

import { api } from 'utils';

const useVerifyContact = (): UseMutationResult<
  { id: string },
  ErrorResponse,
  { data: { code: string }; id: string }
> => {
  return useMutation(({ data, id }) =>
    api.post(`${url.createContact}/${id}/verify`, data)
  );
};

export default useVerifyContact;
